import Preloader from './dooh-react-utils/preload/Preloader';

export let result = [
  require('./assets/result/aohne.mp4'),
  require('./assets/result/aokej.mp4'),
  require('./assets/result/acool.mp4'),
  require('./assets/result/abravo.mp4'),
  require('./assets/result/asuper.mp4'),
  require('./assets/result/atop.mp4'),
];

const preloader = new Preloader(
  [
    ...result,
    require('./assets/bubble.webm'),
    require('./assets/bubble-exit.webm'),
    require('./assets/cta.png'),
    require('./assets/header.png'),
    require('./assets/start.png'),
    require('./assets/thanks.png'),
  ],
  [
    { name: 'Gagalin-Regular', url: require('./assets/Gagalin-Regular.woff') },
    { name: 'Garamond', url: require('./assets/Garamond.woff') },
    { name: 'RalewayBold', url: require('./assets/Raleway-Bold.woff') },
  ]
);

export default preloader;
